(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rbs-collection-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('formdata', function(event) {
    if (!event.target.matches('.rbs-collection-filters__form')) return;
    const data = event.formData;
    for (const [key, value] of Array.from(data.entries())) {
      if (value === '') data.delete(key);
    }
    const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewTheme) data.set('preview_theme_id', previewTheme);
  }, true);
  } catch(e) { console.error(e); }
})();

})();
